"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ui_theme_1 = require("@kyruus/ui-theme");
const styled_1 = __importDefault(require("@emotion/styled"));
const Link = (0, styled_1.default)('a') `
  color: ${(0, ui_theme_1.fromTheme)('color_link')};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
exports.default = Link;
//# sourceMappingURL=styles.js.map